import React, {useState, useEffect} from 'react'

//import components
import Logo from "../assets/img/My project-1.png"
import Nav from "../Components/Nav"
import NavMobile from './NavMobile';
import Socials from './Socials';


function Header() {
    const [bg, setBg] = useState(false);

    useEffect(
        ()=>{
            window.addEventListener('scroll', ()=>{
                return window.scrollY > 50 ? setBg(true) : setBg(false);
            });
        })

  return (
    <header className={`${bg ? 'bg-tertiary h-20' : 'h-24'} flex items-center fixed top-0 w-full text-white z-10 translate-all duration-300`}>
        <div className="container mx-auto h-full flex items-center justify-between">
            {/* logo */}
            <a href="https://github.com/1uckyswish?tab=repositories">
    <img src={Logo} alt="Portfolio name" class="h-[130px]" />
</a>

            {/* nav */}
            <div className='hidden lg:block'>
            
             <Nav />
            </div>
           {/*Socials*/}
            <div className='hidden lg:block'>
             <Socials />
            </div>
            {/*nav mobile*/}
            <div className='lg:hidden'>
             <NavMobile />
            </div>
        </div>
    </header>
  )
};

export default Header